import type { ReactNode } from "react";

interface Props {
  children: ReactNode;
  className?: string;
}

export function Section({
  children,
  className = "",
}: Props) {
  return <section className={className}>{children}</section>;
}